import styled from 'styled-components'

export const Wrapper = styled.div`
  margin: 48px 0;
`

export const CertificationsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 32px;
  grid-row-gap: 32px;
  grid-auto-rows: 1fr;

  @media (max-width: 1600px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 1280px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 769px) {
    grid-template-columns: 1fr;
  }

  section {
    display: flex;
    flex-direction: column;
  }

  input {
    margin-bottom: 18px;
  }
`

export const Certification = styled.section`
  display: flex;

  p {
    min-height: 50px;
    margin-bottom: 8px;
    color: ${({ theme }) => theme.colors.primary};
  }
`
